import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { Category } from '../models';

import { TemplateService } from 'src/app/core/services/template.service';

@Injectable()
export class CategoryListResolver implements Resolve<Observable<Array<Category>>> {
  constructor(private templateService: TemplateService) {}

  resolve() {
    return this.templateService.fetchCategoryDetails();
  }
}